import defaultLocale from '../locale-provider/default';
let runtimeLocale = {
    ...defaultLocale.Notification,
};
export function changeNoticeLocale(newLocale) {
    if (newLocale) {
        runtimeLocale = {
            ...runtimeLocale,
            ...newLocale,
        };
    }
    else {
        runtimeLocale = {
            ...defaultLocale.Notification,
        };
    }
}
export function getNoticeLocale() {
    return runtimeLocale;
}
